import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 3h14a2 2 0 0 1 2 2v14.775a.5.5 0 0 1-.168.374l-1.75 1.556a.5.5 0 0 1-.664 0L16.5 20l-1.918 1.705a.5.5 0 0 1-.664 0L12 20l-1.918 1.705a.5.5 0 0 1-.664 0L7.5 20l-1.918 1.705a.5.5 0 0 1-.664 0l-1.75-1.556A.5.5 0 0 1 3 19.775V5a2 2 0 0 1 2-2zm14 1H5a1 1 0 0 0-1 1v14.586l1.143 1 1.956-1.712a.5.5 0 0 1 .659 0l1.956 1.712 1.957-1.712a.5.5 0 0 1 .658 0l1.957 1.712 1.956-1.712a.5.5 0 0 1 .659 0l1.956 1.712 1.143-1V5a1 1 0 0 0-1-1z"
});

var SvgOrder = function SvgOrder(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgOrder;